import React from 'react';
import { NumberInputWUT } from '../../inputs/number-input-wut/number-input-wut';
import { useFieldAttributes } from '../../sdk/components';
import { FieldDescriptionWUT, FieldErrorWUT, FieldLabelWUT } from '../../sdk/components-wut';
export const NumberInputFieldWUT = ({ id, target, value, validation, required, label, hideLabel, disabled, readOnly, placeholder, onChange, onBlur, description, onFocus, error, hasError = false, errorMessage, media, mediaSettings, FieldLayout, requiredIndicatorType, requiredIndicatorPlacement })=>{
    const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id,
        renderLabel: ()=>/*#__PURE__*/ React.createElement(FieldLabelWUT, {
                labelId: labelId,
                htmlFor: inputId,
                required: required,
                label: label,
                hideLabel: hideLabel,
                requiredIndicatorType: requiredIndicatorType,
                requiredIndicatorPlacement: requiredIndicatorPlacement,
                media: media,
                mediaSettings: mediaSettings
            }),
        renderInput: ()=>/*#__PURE__*/ React.createElement(NumberInputWUT, {
                value: value,
                validation: validation,
                required: required,
                label: label,
                disabled: disabled,
                readOnly: readOnly,
                placeholder: placeholder,
                onChange: onChange,
                onBlur: onBlur,
                onFocus: onFocus,
                hasError: hasError,
                inputId: inputId,
                ariaDescribedBy: ariaDescribedBy,
                fieldId: id
            }),
        renderDescription: ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FieldErrorWUT, {
                target: target,
                hasError: hasError,
                errorMessage: errorMessage,
                id: errorId
            }), /*#__PURE__*/ React.createElement(FieldDescriptionWUT, {
                description: description,
                id: descriptionId
            }))
    });
};

//# sourceMappingURL=number-input-field-wut.js.map